@if (rule) {
  <app-card>
    <div class="header">
      <h3 class="flex">
        <app-icon name="ic_irrigation"/>
        <span class="line-clamp">{{ rule | ruleName }}</span>
      </h3>
      <mat-slide-toggle [ngModel]="rule.isActive" (ngModelChange)="onChangeIsActive($event)" [disabled]="disabled" class="end"/>
      <app-context-menu [menuItems]="contextMenu"/>
    </div>

    <div class="content">
      {{ description }}
    </div>

    <div class="footer">
      <div class="flex">
        @if (conditions.length === 1) {
          <app-text-with-icon [name]="conditions[0].type | icons">
            {{ LabelConverter.getFormConditionTypeLabel(conditions[0].type) | translate }}
          </app-text-with-icon>
        } @else {
          @for (condition of conditions.slice(0, limit); track condition) {
            <app-icon [name]="condition.type | icons"/>
          }
          @if (conditions.length > limit) {
            <span>+</span>
          }
        }
      </div>
      <a class="button icon-button end" [routerLink]="['/', RouteConstants.routeRule, rule.id]" routerLinkActive="active">
        {{ 'default.details' | translate }}
        <app-icon name="ic_chevron_right"/>
      </a>
    </div>
  </app-card>
}
